export default {
  title: 'API-sleutel aanmaken',
  reveal_warning: 'Bewaar deze sleutel nu — hij wordt niet nogmaals getoond.',
  form: {
    name: 'Naam',
    name_placeholder: 'bijv. Productiesleutel',
  },
  buttons: {
    cancel: 'Annuleren',
    create: 'Aanmaken',
    done: 'Klaar',
  },
  toasts: {
    error: 'Kan de sleutel niet aanmaken. Probeer het opnieuw.',
  },
};
